import { useRef } from "react";
import { useLabStats } from "../lib/api";
import { useCountUp, useInView } from "../lib/hooks";

function CountTile({ target, label, active }: { target: number; label: string; active: boolean }) {
  const value = useCountUp(target, active);
  return (
    <div className="screen flex flex-col items-start gap-2 p-5">
      {/* 7-segment amber VFD readout (odometer-style, no separators) */}
      <span className="text-glow font-dseg text-[clamp(28px,5vw,44px)] leading-none tabular-nums text-amber">
        {value}
      </span>
      <span className="vfd-box">{label}</span>
    </div>
  );
}

/** The three live lab counters (rolls / drop-offs / customers). Nothing loads
 *  — neither the fetch nor the count-up — until the block scrolls into view. */
export function LabStats() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref);
  const stats = useLabStats(inView);

  return (
    <div ref={ref}>
      <div className="grid grid-cols-1 gap-3.5 min-[560px]:grid-cols-3">
        <CountTile target={stats.rolls} label="rolls developed" active={inView} />
        <CountTile target={stats.drop_offs} label="drop-offs" active={inView} />
        <CountTile target={stats.customers} label="unique customers" active={inView} />
      </div>
      <p className="mt-2 font-mono text-[13px] italic text-text-mute">
        since 1/1/25, live updating!
      </p>
    </div>
  );
}
